import { configureStore, combineReducers } from "@reduxjs/toolkit";
import calculatorsReducer from "./features/calculators/calculatorsSlice";
import propertiesReducer from "./features/mortgage/propertySlice";
import tiersReducer from "./features/mortgage/tiersSlice";
import totalsReducer from "./features/costPer/totalsSlice";
import expensesReducer from "./features/costPer/expensesSlice";
import settingsReducer from "./features/channelMix/settingsSlice";
import inputsReducer from "./features/channelMix/inputsSlice";
import outputsReducer from "./features/channelMix/outputsSlice";

const store = configureStore({
	reducer: {
		calculators: calculatorsReducer,
		mortgage: combineReducers({properties: propertiesReducer, tiers: tiersReducer}),
		costPer: combineReducers({totals: totalsReducer, expenses: expensesReducer}),
		channelMix: combineReducers({settings: settingsReducer, inputs: inputsReducer, outputs: outputsReducer})
	}
});

export default store;